'use client';

import { ReactNode } from 'react';
import * as styles from './address-block.css';

export interface AddressBlockProps {
  /** Uppercase label rendered above the address lines (e.g. "DELIVERING TO"). */
  label: string;
  /** Bold primary line of the address. */
  primary: ReactNode;
  /** Optional secondary line(s) — city / state / zip / notes. */
  secondary?: ReactNode;
  'data-id'?: string;
}

/**
 * Boxed address block used in the Delivery state for the destination address and
 * (variant pattern) in any other place that needs a labeled multi-line block.
 */
export const AddressBlock = ({ label, primary, secondary, ...rest }: AddressBlockProps) => (
  <div className={styles.block} {...rest}>
    <div className={styles.label}>{label}</div>
    <div className={styles.line}>{primary}</div>
    {secondary ? <div className={styles.detail}>{secondary}</div> : null}
  </div>
);
